import { useState, useMemo, useEffect } from "react";
import { Button, Chip } from "@mui/material";
// import HistoryIcon from "@mui/icons-material/History";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  fetchMandateHistoryByConsumerId,
  getBookingIdFromAllotmentPaymentId,
} from "../../Services/Allotment";
import {
  CheckCircle as CheckCircleIcon,
  History as HistoryIcon,
  Circle as CircleIcon,
} from "@mui/icons-material";
import EMandateHistoryModal from "../../Modals/EMandate/EMandateHistoryModal";

const MandateStatus = ({ selectedMandateData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [bookingIdData, setBookingIdData] = useState(null);
  const [currentMandateData, setCurrentMandateData] = useState({});
  const [agreementFormDetails, setAgreementFormDetails] = useState([]);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const allotmentPaymentId = selectedMandateData?.allotmentPaymentId;
  const [historyData, setHistory] = useState([]);

  console.log("selectedMandateData:", selectedMandateData);

  // Utility function for status color and background
  const getStatusColor = (status) => {
    const statusColors = {
      "Not Initiated": "#757575",
      Initiated: "#1976D2",
      Pending: "#ED6C02",
      Verified: "#2E7D32",
      Deactivated: "#BDBDBD", // Light Gray for Deactivated status
    };
    return statusColors[status] || "#757575"; // Default color
  };

  const getStatusBg = (status) => {
    const statusBg = {
      "Not Initiated": "#EEEEEE",
      Initiated: "#E3F2FD",
      Pending: "#FFEBEE",
      Verified: "#E8F5E9",
      Deactivated: "#F5F5F5", // Very Light Gray background for Deactivated
    };
    return statusBg[status] || "#EEEEEE"; // Default background
  };

  const getStatusLabel = (status) => {
    const statusLabels = {
      "Not Initiated": "Not Initiated",
      Initiated: "Initiated",
      Pending: "Pending",
      Verified: "Verified",
      Deactivated: "Deactivated",
    };
    return statusLabels[status] || "Unknown Status"; // Default label
  };

  // const fetchHistoryData = async () => {
  //   if (!selectedMandateData?.consumerId) return;

  //   console.log(
  //     "Fetching history for consumerId:",
  //     selectedMandateData.consumerId,
  //   );
  //   try {
  //     const response = await fetchMandateHistoryByConsumerId(
  //       selectedMandateData?.consumerId,
  //     );
  //     console.log("Fetched eMandate history:", response);
  //     setHistory(response.data.data); // Assuming response.data.data contains the history array
  //   } catch (err) {
  //     console.error("Error fetching eMandate history:", err);
  //     // setError("Failed to load eMandate history");
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  const fetchHistoryData = async (consumerId) => {
    if (!consumerId) return;

    try {
      const response = await fetchMandateHistoryByConsumerId(consumerId);
      // console.log("Fetched eMandate history:", response);

      const rawData = response?.data || [];

      const sortedHistory = rawData
        .flatMap((item) => item?.attempts || [])
        .sort(
          (a, b) => new Date(b?.ActionDate || 0) - new Date(a?.ActionDate || 0),
        );
      // console.log("Fetched eMandate sortedHistory:", sortedHistory);

      setHistory(sortedHistory);
    } catch (err) {
      console.error(err);
    }
  };

  const handleViewHistory = (allotment) => {
    setHistoryOpen(true);

    if (selectedMandateData?.consumerId) {
      fetchHistoryData(selectedMandateData.consumerId);
    }
  };

  // Memoize API call to avoid repeated calls
  const fetchBookingId = useMemo(() => {
    const fetchBookingIdFromAPI = async () => {
      try {
        const result =
          await getBookingIdFromAllotmentPaymentId(allotmentPaymentId);
        setBookingIdData(result?.data?.bookingId);
        setAgreementFormDetails(result?.agreementFormData);
        // console.log(
        //   "getBookingIdFromAllotmentPaymentId:",
        //   result?.agreementFormData,
        // );
      } catch (error) {
        console.error("Failed to fetch Booking ID:", error);
      }
    };

    if (
      allotmentPaymentId &&
      !bookingIdData &&
      agreementFormDetails.length === 0
    ) {
      fetchBookingIdFromAPI();
    }

    return bookingIdData;
  }, [allotmentPaymentId, bookingIdData]);

  // Function to match PAN and return the contact number
  useEffect(() => {
    if (!selectedMandateData) return;

    // console.log(
    //   "Running PAN match for selectedMandateData:",
    //   selectedMandateData,
    // );
    const agreementFormData = agreementFormDetails[0]?.applicants;
    // console.log("agreementFormData:", agreementFormData);

    // Use find() to directly search for the matching data
    const matchedData = agreementFormData?.find((data) => {
      const applicantPan = data?.applicant?.panNumber;
      return String(applicantPan) === String(selectedMandateData.pan); // Ensure both are strings for comparison
      // });
    });

    if (matchedData) {
      // console.log("Matched applicant data:", matchedData);
      setCurrentMandateData({
        ...selectedMandateData,
        contactNumber: matchedData?.applicant?.contactNumber,
      });
    }
  }, [selectedMandateData, agreementFormDetails]);

  // Handle Mandate action (e.g., Reactivate or Initiate Mandate)
  const handleMandate = () => {
    console.log("currentMandateData before navigate:", currentMandateData);
    // currentMandateData.calculatedPercentage = totalma;
    currentMandateData.splitAmount = currentMandateData.emandateAmount;
    currentMandateData.splitRatio = currentMandateData.splitRatio;
    navigate("/Home/BankVerification", {
      state: {
        allotmentPaymentId:
          selectedMandateData?.allotmentPaymentId || allotmentPaymentId,
        currentApplicant: [currentMandateData],
        bookingId: bookingIdData,
      },
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: 20,
        boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
        marginBottom: 24,
      }}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #E0E0E0",
          paddingBottom: 12,
          marginBottom: 16,
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <VerifiedIcon sx={{ color: "#1976D2", fontSize: "2rem" }} />
          <span style={{ fontSize: 16, fontWeight: 600 }}>
            Mandate Current Status
          </span>
        </div>

        <Button
          variant="outlined"
          size="small"
          startIcon={<HistoryIcon />}
          onClick={() => {
            handleViewHistory(selectedMandateData);
          }}
          sx={{ textTransform: "none", fontSize: 13 }}
        >
          View History
        </Button>
      </div>

      {/* MANDATE DETAILS */}
      {selectedMandateData && (
        <div
          key={selectedMandateData?.mandateId}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 32,
            padding: "16px 0",
            borderBottom: "1px dashed #E0E0E0",
            flexWrap: "wrap",
          }}
        >
          {/* STATUS */}
          <div>
            <div style={{ fontSize: 13, color: "#757575", marginBottom: 6 }}>
              Status
            </div>
            <Chip
              label={getStatusLabel(selectedMandateData?.emandateStatus)}
              sx={{
                backgroundColor: getStatusBg(
                  selectedMandateData.emandateStatus,
                ),
                color: getStatusColor(selectedMandateData.emandateStatus),
                fontWeight: 600,
                fontSize: 13,
              }}
            />
          </div>

          {/* MANDATE ID */}
          <div>
            <div style={{ fontSize: 13, color: "#757575", marginBottom: 6 }}>
              Mandate ID
            </div>
            <div style={{ fontSize: 15, fontWeight: 600 }}>
              {selectedMandateData.mandateId || "-"}
            </div>
          </div>

          {/* ACTION */}
          <div style={{ marginLeft: "auto" }}>
            {selectedMandateData.emandateStatus === "Pending" && (
              <Button
                variant="contained"
                size="small"
                sx={{ textTransform: "none", fontSize: 13 }}
                onClick={handleMandate}
              >
                Activate Mandate
              </Button>
            )}

            {/* {selectedMandateData.emandateStatus === "Not-Initiated" && (
              <Button
                variant="contained"
                size="small"
                sx={{ textTransform: "none", fontSize: 13 }}
              >
                Initiate Mandate
              </Button>
            )} */}
             {selectedMandateData.emandateStatus === "Deactivated" && (
              <Button
                variant="contained"
                size="small"
                sx={{ textTransform: "none", fontSize: 13 }}
                 onClick={handleMandate}
              >
                Initiate Mandate
              </Button>
            )}
          </div>
        </div>
      )}
      {/* HISTORY MODAL */}

      <EMandateHistoryModal
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        historyData={historyData}
      />
    </div>
  );
};

export default MandateStatus;